import { FC } from 'react';

import { Panel } from '../PanelLayout';
import { PanelTemplateProps } from '../types';

const FooterPanel: FC<PanelTemplateProps> = ({ children, ...otherProps }) => {
  return (
    <Panel name="footer" {...otherProps}>
      {children}
    </Panel>
  );
};

export default FooterPanel;
